import 'directiveLoader'
import './configs/routeConfigs'
import 'routes'
